import { Link } from 'react-router-dom';
import { Container } from '@/components/Container';
import { useLocalizedPath } from '@/hooks/useI18n';
import { useTranslation } from '@/hooks/useTranslation';
import { depoimentos } from './data';

function Avatar({ nome }: { nome: string }) {
  const initials = nome
    .split(' ')
    .map(n => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
  return (
    <div className="w-10 h-10 rounded-full bg-teal-deep text-white flex items-center justify-center font-body font-bold text-sm">
      {initials}
    </div>
  );
}

export function DepoimentosSection() {
  const { t } = useTranslation();
  const localize = useLocalizedPath();

  return (
    <section className="py-16 sm:py-20 bg-sand-50">
      <Container>
        <div className="text-center mb-10">
          <span className="font-body text-sm text-coral font-semibold uppercase tracking-wider">
            {t('home.testimonials.overline')}
          </span>
          <h2 className="font-display text-4xl sm:text-5xl text-warm-dark mt-1">
            {t('home.testimonials.title')}
          </h2>
          <p className="font-editorial text-lg text-warm-gray mt-3">
            {t('home.testimonials.subtitle')}
          </p>
        </div>

        <div className="text-center mb-10 max-w-2xl mx-auto">
          <Link
            to={localize('/experiencias')}
            className="inline-flex items-center gap-2 bg-coral hover:bg-[#c96a52] text-white font-body font-semibold rounded-xl px-6 py-3 transition-all hover:-translate-y-0.5"
          >
            {t('home.testimonials.cta')}
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {depoimentos.map(dep => (
            <div
              key={dep.nome}
              className="bg-white rounded-2xl border border-sand-200 p-6 shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:shadow-md transition-shadow"
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: dep.nota }).map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-amber-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              <svg className="w-8 h-8 text-sand-300 mb-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
              </svg>

              <p className="font-body text-warm-dark leading-relaxed mb-5 italic">"{dep.texto}"</p>

              <div className="flex items-center gap-3 pt-4 border-t border-sand-100">
                <Avatar nome={dep.nome} />
                <div>
                  <div className="font-body text-sm font-semibold text-warm-dark">{dep.nome}</div>
                  <div className="font-body text-xs text-warm-gray">{dep.local}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
